<template>
    <div>
      <pcbForm
        ref="formPlusRef"
        v-if="Object.keys(state.option).length > 0"
        :key="key"
        v-model="state.formData"
        v-bind="$attrs"
        :option="state.option"
        @submit="handleSubmit"
        @form-change="handleFormChange"
      >
    <template v-for="(_, name) in $slots" #[name]="slotData">
      <slot :name v-bind="slotData || {}"></slot>
    </template>
    </pcbForm>
    <div v-if="state.option.debug===true&&localhost==='localhost'">
      <span class="debug-json-view-toggle" style="cursor: pointer;" @click="showDebug=!showDebug">{{ showDebug?'>':'=' }}</span>
      <div v-if="showDebug===true" class="debug-json-view">
        <JsonViewer :preview-mode="true" class="json-viewer-container" :value="state.formData" copyable theme="light"    />
      </div>
    </div>
    </div>
  </template>
  
  <script setup>
  import { useForm } from '../hooks/useForm.js'; // 导入通用 hook
  import pcbForm from './pcb-form.vue';
  import { JsonViewer } from "vue3-json-viewer";
  import "vue3-json-viewer/dist/vue3-json-viewer.css"
  import { useSlots,ref,unref,onMounted,nextTick } from 'vue';
  const { state, init, key,events } = useForm();
  const emits = defineEmits(["submit",'created','change']);
  const localhost=window.location.hostname
  const showDebug=ref(false)
  const handleSubmit=(val,done)=>{
    done()
    emits("submit",unref(val))
  }
  const formPlusRef=ref(null)
  const submit = async () => {
    try {
      const data = await formPlusRef.value.submit()
      return data
    } catch (error) {
      return {
        errors: error,
        values: state.formData
      }
    }
  }
  defineOptions({
    name: 'pcb-form-plus',
  });
  function handleFormChange(val,item){
    // 直接使用接收到的 val 参数，这是最新的 formData 值
    // 不要使用 state.formData，因为 v-model 同步可能有延迟
    emits("change",val,item)
  }
  onMounted(async ()=>{
    // 使用 nextTick 确保组件完全挂载后再发出 created 事件
    await nextTick()
    // 再延迟一点时间，确保 Web Component 的事件监听器已经绑定
    setTimeout(() => {
      emits("created",{
        name:"pcb-form-plus",
      })
    }, 50)
  })
  // 将 init 暴露给外部调用
  defineExpose({
    init,
    ...events,
    formPlusRef,
    submit,
  });
  </script>
  <style scoped>
.debug-json-view{
  position: fixed;
  right: 5px;
  top: 5vh;
  width: 20%;
  z-index: 1000000;
  height: 90vh;
  background-color: rgba(255, 255, 255, 0.95);
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.debug-json-view-toggle{
  position: fixed;
  right: 5px;
  top: 50vh;
  z-index: 1000001;
  background-color: #007bff;
  color: white;
  padding: 8px 12px;
  border-radius: 4px;
  font-weight: bold;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  user-select: none;
}
.json-viewer-container {
  height: 100%;
  width: 100%;
  background-color: #fff;
  overflow-y: auto;
  
  /* 隐藏滚动条但保持滚动功能 */
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
}

/* Webkit浏览器（Chrome, Safari等）隐藏滚动条 */
.json-viewer-container::-webkit-scrollbar {
  display: none;
}
</style>

  